import { render, staticRenderFns } from "./LeaveEdit.vue?vue&type=template&id=622c7e3c"
import script from "../../controllers/leave/leave-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/leave/leave-edit.js?vue&type=script&lang=js&external"
import style0 from "./LeaveEdit.vue?vue&type=style&index=0&id=622c7e3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports